import { Directive, ElementRef, Input, AfterViewInit } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { TranslationService } from "../../../services/translation.service";
import { PermissionsInfo } from "../../../components/permissions-info";

@Directive({
    selector: "button[actionButton]",
    providers: [TranslatePipe],
    standalone: false
})
export class ActionButtonDirective implements AfterViewInit {

    @Input() templateType: 'New' | 'Danger' | 'Save' | 'SaveExit' | 'Action' | 'Add' | 'Edit';
    @Input() templateTitleKey: string;

    @Input() specialAction: string;
    @Input() permissions: PermissionsInfo;

    private get htmlElement(): HTMLElement {
        return this.elementRef.nativeElement as HTMLElement;
    }

    constructor(private elementRef: ElementRef, private translationService: TranslationService, private translatePipe: TranslatePipe) {
        this.htmlElement.hidden = true;
    }

    ngAfterViewInit(): void {

        let cssClasses: string[] = [];
        let translatedTitle;
        switch (this.templateType) {
            case 'New':
                cssClasses = ['btn', 'btn-complete', 'btn-add'];
                translatedTitle = this.templateTitleKey ?
                    this.translatePipe.transform(this.templateTitleKey) :
                    this.translationService.translate(x => x.Common.SearchActionsAndDetailsActions.New);
                break;
            case 'Danger':
                cssClasses = ['btn', 'btn-danger'];
                translatedTitle = this.templateTitleKey ?
                    this.translatePipe.transform(this.templateTitleKey) :
                    this.translationService.translate(x => x.Common.SearchActionsAndDetailsActions.New);
                break;
            case 'Action':
                cssClasses = ['btn', 'btn-complete'];
                translatedTitle = this.templateTitleKey ?
                    this.translatePipe.transform(this.templateTitleKey) :
                    this.translationService.translate(x => x.Common.SearchActionsAndDetailsActions.New);
                break;
            case 'Save':
                cssClasses = ['btn', 'btn-success'];
                translatedTitle = this.templateTitleKey ?
                    this.translatePipe.transform(this.templateTitleKey) :
                    this.translationService.translate(x => x.Common.SearchActionsAndDetailsActions.Save);
                break;
            case 'SaveExit':
                cssClasses = ['btn', 'btn-success'];
                translatedTitle = this.templateTitleKey ?
                    this.translatePipe.transform(this.templateTitleKey) :
                    this.translationService.translate(x => x.Common.SearchActionsAndDetailsActions.SaveAndExit);
                break;
            case 'Add':
                cssClasses = ['btn', 'btn-complete', 'btn-add', 'btn-append'];
                break;
            case 'Edit':
                cssClasses = ['btn', 'btn-complete', 'btn-edit', 'btn-append'];
                break;
        }

        if (translatedTitle) {
            this.htmlElement.innerText = translatedTitle;
        }

        if (cssClasses.length) {
            this.htmlElement.classList.add(...cssClasses);
        }
    }

    toggleDisplay(makeDisplayed: boolean) {
        this.htmlElement.hidden = !makeDisplayed;
    }
}
